import React from 'react';
import PropTypes from 'prop-types';
import ProceduresFormContext from '../../../components/context';
import {i18nInit} from 'root/internationalization/config';


export default class RatingScale extends React.Component {
    static contextType = ProceduresFormContext;

    constructor(props) {
        super(props);

        this.ratingData = this.props.data;
        this.ratingData.sort((a,b) => {
            if (a.RATING_NR < b.RATING_NR) return -1;
            if (a.RATING_NR > b.RATING_NR) return 1;
            return 0;
        });

        if (this.props.hasNA) {
            this.ratingData.push({
                COLOR: "",
                RATING_CD: 0,
                RATING_DESC: "Not Applicable",
                RATING_NR: "N/A",
                RATING_VALUE: "N/A",
                WEIGHT: '',
            });
        }

        let lastDescription = "";
        this.ratingData.map((item,i) => {
            if(item.RATING_DESC == ""){
                item.RATING_DESC = lastDescription;
            }

            lastDescription = item.RATING_DESC;
        });

        this.state = {
            ratingAnswer: this._getCurrentAnswer(this.props.value),
            transition: false,
        }
    }

    componentDidUpdate(prevProps, prevState){
        if (typeof this.props.onChange == "function") {
            if (this.state != prevState && this.state.ratingAnswer){
                this.props.onChange(this.state.ratingAnswer.RATING_CD);
            }
        }
    }

    _getCurrentAnswer(answer){
        let index;
        for (index = 0; index < this.ratingData.length; ++index) {
            if (answer.toString() === this.ratingData[index].RATING_CD.toString()){
                return this.ratingData[index];
            }
        }

        return {
            RATING_VALUE: "",
            WEIGHT: "",
            RATING_DESC: !this.props.readOnly ? this.props.placeholder : "",
            COLOR: "",
            RATING_CD: "",
        }
    }

    _processRatingScaleTap(element){
        if(!this.props.readOnly){
            let elementValue = element.target.getAttribute('data-value');

            if (this.state.ratingAnswer && this.state.ratingAnswer.RATING_CD == elementValue){
                elementValue = "";
            }

            let transition = true;
            if (!this.state.ratingAnswer.RATING_CD) {
                transition = false;
            }
            this.setState({
                transition: transition,
                ratingAnswer: this._getCurrentAnswer(elementValue),
            },()=> {
                setTimeout(() => {
                    this.setState({
                        transition: false,
                    });
                }, 300);
            });
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className="grades" 
                    // style={{ backgroundColor: this.state.ratingAnswer ? this.state.ratingAnswer.COLOR : "" }}
                    >
                    <div className="grades grades__bg">
                        {this.ratingData.map((data) => {
                            return <div 
                                        className={`col grade 
                                            ${this.state.ratingAnswer.RATING_CD === data.RATING_CD || !this.state.ratingAnswer.RATING_CD || this.state.transition ? 'show' : ''} 
                                            ${!this.state.transition && this.state.ratingAnswer.RATING_CD === data.RATING_CD? 'active' : ''}
                                        `} 
                                        key={data.RATING_CD} 
                                        style={{ backgroundColor: data.COLOR }}>
                                    </div>
                        })}
                    </div>
                    {this.ratingData.map((data) => {
                        return (
                          <div className="col grade" key={data.RATING_CD}>
                            <span
                              tabIndex={0}
                              aria-label={data.RATING_DESC}
                              className={
                                this.state.ratingAnswer &&
                                this.state.ratingAnswer.RATING_CD ===
                                  data.RATING_CD
                                  ? "active"
                                  : ""
                              }
                              data-value={data.RATING_CD}
                              onClick={this._processRatingScaleTap.bind(this)}
                            >
                              {data.RATING_CD == "NA"
                                ? data.RATING_DESC
                                : data.RATING_VALUE}
                            </span>
                          </div>
                        );
                    })}
                </div>
                <div 
                    className={`grade-desc text-center mt-3 ${this.state.ratingAnswer.RATING_VALUE == '' ? 'color-grey' : ''}`}
                >
                    {this.state.ratingAnswer && this.state.ratingAnswer.RATING_DESC ? this.state.ratingAnswer.RATING_DESC : null}
                </div>
            </React.Fragment>
        )
    }
}

RatingScale.defaultProps = {
    placeholder: i18nInit.t("lbl.SELECT_A_VALUE","Select a value"),
    readOnly: false,
    hasNA: false,
}

RatingScale.propTypes = {
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    hasNA: PropTypes.bool,
}